import PhotosToolbar from './PhotosToolbar';

export default PhotosToolbar;
